<template>
  <div ref="containerRef">
    <h2
      class="text-center mb-6"
      v-if="
        headerText &&
        !services.every((element) => !showServiceCard(element))
      "
    >
      {{ headerText }}
    </h2>
    <div :class="gridClasses" v-if="!isCarousel">
      <ServicesCard
        v-for="service in filteredServices"
        :key="service.ServiceDefId"
        :discountText="discountText"
        :service="service"
        :size="size"
        :neighborhoodDiscountText="neighborhoodDiscountText"
        :isAddonServiceCard="isAddonServiceCard"
        :layout="layout"
        :borderOverride="borderOverride"
        :packageServices="packageServices"
      />
    </div>
    <Carousel
      v-else
      :items-to-show="carouselSlidesDisplayed"
      :items-to-scroll="carouselSlidesDisplayed"
      :autoplay="0"
      :wrapAround="true"
      snap-align="start"
    >
      <Slide v-for="service in filteredServices" :key="service.ServiceDefId" >
        <ServicesCard
          :key="'isCarousel' + service.ServiceDefId"
          :discountText="discountText"
          :service="service"
          :size="size"
          :isCarousel="true"
          :neighborhoodDiscountText="neighborhoodDiscountText"
          :isAddonServiceCard="isAddonServiceCard"
          :layout="layout"
          class="carousel-slide mx-4"
        />
      </Slide>
      <template #addons>
        <Navigation />
      </template>
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import { Carousel, Slide, Navigation } from "vue3-carousel";
import type ServiceState from "~/domains/store/services/ServiceState";

interface Props {
  services: ServiceState[];
  size?: string;
  neighborhoodDiscountText?: string;
  discountText?: string;
  borderOverride?: string;
  hidePurchased?: boolean;
  hideUnavailable?: boolean;
  headerText?: string;
  isCarousel?: boolean;
  isAddonServiceCard?: boolean;
  layout?: string;
  packageServices?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: "medium",
});

const showServiceCard = (service: ServiceState) => {
	if (props.hidePurchased && service.showHasPurchased) return false;
	if (
		props.hideUnavailable &&
		!service.showPurchase &&
		!service.showCheckAvailability &&
		!service.showHasPurchased
	)
		return false;
	return true;
};

const filteredServices = computed(() => {
	return props.services?.filter((service) => showServiceCard(service));
});

const gridClasses = computed(() => {
  let baseStyle = "grid clear-both mb-8 ";
  baseStyle += props.layout === "listview" ? "gap-8" : "gap-4";
  if (props.size == "small") {
    return baseStyle + " lg:grid-cols-3";
  } else if (props.size == "medium") {
    return baseStyle + " md:grid-cols-2";
  } else {
    return baseStyle;
  }
});

// Carousel Resizing State and Logic
const containerRef = ref<HTMLElement>();
const containerWidth = ref(0);

const updateContainerWidth = () => {
  if (containerRef.value) {
    containerWidth.value = containerRef.value.offsetWidth;
  }
};

const carouselSlidesDisplayed = computed(() => {
  if (containerWidth.value >= 800) {
    return 3;
  } else if (containerWidth.value >= 550) {
    return 2;
  } else {
    return 1;
  }
});

// Lifecycle hooks
onMounted(() => {
  updateContainerWidth();
  window.addEventListener('resize', updateContainerWidth);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateContainerWidth);
});
</script>

<style scoped>
</style>
